var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isAssetLoading)?_c('div',{staticClass:"asset-loading-container bg"},[_c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('系统加载中'))+"...")])])]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }